<!-- OTP verify dialog — only shown when the member isn't KYC-verified yet -->
<p-dialog [visible]="showOtp()" (visibleChange)="showOtp.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [dismissableMask]="false" header="Verify Member" styleClass="otp-flow-dialog"
  [style]="{ width: '460px' }" [breakpoints]="{ '460px': '94vw' }">
  <p class="flow-hint">
    Verify <strong>{{ member()?.name || 'this member' }}</strong> with the OTP sent to their registered
    contact — the payment opens automatically once verified.
  </p>
  @if (sendingOtp()) {
    <span class="flow-muted"><i class="pi pi-spin pi-spinner"></i> Sending OTP…</span>
  } @else if (member()) {
    <app-otp-step [memberId]="member()!.id" [channels]="otpChannels()" [expiresInMinutes]="otpExpiry()"
      [otpSent]="otpSent()" [otpMessage]="otpMessage()" (verified)="onVerified()" />
  }
</p-dialog>

<!-- brief blocking overlay while the member resolves / the order is created -->
<p-dialog [visible]="starting()" [modal]="true" [closable]="false" [draggable]="true" [resizable]="false"
  [showHeader]="false" styleClass="starting-dialog" [style]="{ width: '300px' }">
  <div class="flow-starting"><i class="pi pi-spin pi-spinner"></i> Starting secure payment…</div>
</p-dialog>

<!-- Offered when the gateway refuses the payment because the member has no e-mail. Saving it
     continues straight into the payment that was interrupted. -->
<app-member-email-dialog [memberId]="member()?.id || 0" [memberName]="member()?.name || null"
  gatewayName="Generali Central" (saved)="onEmailSaved($event)" />

<!-- Redirect gateway in progress. The customer is paying in the popup; this keeps the app on
     screen behind it (the same feel as Razorpay's modal) and settles when the payment does.
     Not closable: the payment is live, and a stray click must not lose the reference. -->
<p-dialog [visible]="awaitingGateway()" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" [showHeader]="false" styleClass="starting-dialog" [style]="{ width: '380px' }">
  <div class="flow-waiting">
    <i class="pi pi-spin pi-spinner"></i>
    <p><strong>Waiting for the payment…</strong></p>
    <small>
      Complete the payment in the window that opened. This updates by itself — don't close this page.
    </small>
    <p-button label="Bring payment window forward" icon="pi pi-external-link" size="small"
      [text]="true" (onClick)="focusGatewayWindow()" />
  </div>
</p-dialog>

<!-- post-payment success — offer the receipt + certificate -->
<p-dialog [visible]="showSuccess()" (visibleChange)="showSuccess.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [dismissableMask]="true" header="Payment successful" styleClass="otp-flow-dialog"
  [style]="{ width: '440px' }" [breakpoints]="{ '440px': '94vw' }">
  <div class="flow-success">
    <i class="pi pi-check-circle"></i>
    <p><strong>{{ member()?.name || 'Member' }}</strong> is now insured (PAID).</p>
    <div class="flow-success-actions">
      <p-button label="View Receipt" icon="pi pi-receipt" [outlined]="true" (onClick)="openReceipt()" />
      @if (coiMemberId()) {
        <p-button label="View Certificate" icon="pi pi-id-card" (onClick)="openCoi()" />
      }
    </div>
  </div>
</p-dialog>

<!-- receipt dialog (opened from the success panel) -->
<p-dialog [visible]="showReceipt()" (visibleChange)="showReceipt.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [dismissableMask]="true" header="Payment Receipt" styleClass="menu-dialog"
  [style]="{ width: '720px' }" [breakpoints]="{ '720px': '94vw' }">
  @if (showReceipt()) {
    <app-receipt-view [paymentId]="receiptPaymentId()" />
  }
</p-dialog>

<!-- certificate dialog (opened from the success panel) -->
<p-dialog [visible]="showCoi()" (visibleChange)="showCoi.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [dismissableMask]="true" header="Certificate of Insurance" styleClass="menu-dialog"
  [style]="{ width: '900px' }" [breakpoints]="{ '960px': '96vw' }">
  @if (showCoi()) {
    <app-coi-view [memberId]="coiMemberId()" />
  }
</p-dialog>
